import { jsx, Fragment } from "react/jsx-runtime";
import { useClassName } from "@contember/react-utils";
import { usePortalProvider } from "@contember/ui";
import { SortableContainer } from "react-sortable-hoc";
const SortableRepeaterContainerInner = SortableContainer(({ children }) => /* @__PURE__ */ jsx(Fragment, { children }));
const SortableRepeaterContainer = ({ helperClass, ...props }) => /* @__PURE__ */ jsx(
  SortableRepeaterContainerInner,
  {
    helperContainer: usePortalProvider(),
    ...props,
    helperClass: useClassName("root-no-display", helperClass)
  }
);
SortableRepeaterContainer.displayName = "SortableRepeaterContainer";
export {
  SortableRepeaterContainer
};
//# sourceMappingURL=SortableRepeaterContainer.js.map
